var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container_brand"},[_c('HomeHead'),_c('el-image',{attrs:{"src":require('../../assets/images/brand/Scene-1.jpg'),"fit":"fill"}}),_c('el-image',{attrs:{"src":require('../../assets/images/brand/Scene-2.jpg'),"fit":"fill"}}),_c('HomeFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }